import {
  Box,
  Card,
  makeStyles,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FC, useCallback } from 'react';

import 'react-tabs/style/react-tabs.css';
import _debounce from 'lodash/debounce';
// import RichTextInput from 'ra-input-rich-text';
import 'easymde/dist/easymde.min.css';
// import SimpleMdeReact from 'react-simplemde-editor/dist/SimpleMdeReact';
// import 'easymde/dist/easymde.min.css';
// import * as MarkdownEditor from '@uiw/react-markdown-editor';
import './index.css';
import ImagesField, { ImagesTypeEnum } from './imagesField/ImagesField';
import ImagesUploader from '../common/images-uploader';

interface Props {
  isBlocked: boolean;
  changeStatus: () => void;
  isShow: boolean;
}

const ImagesAssetsTab: FC<any> = ({
  isBlocked,
  changeStatus,
  isShow,
  record,
  ...props
}) => {
  return (
    <div className='user-profile-container'>
      <Box>
        <ImagesUploader />
        {/* <ImagesField
          error={false}
          title='Add images for desktop'
          awsFolder='blogs'
          imagesKey={record.galleryImages ? record.galleryImages : undefined}
        /> */}
      </Box>
    </div>
  );
};

export default ImagesAssetsTab;
